import { connect } from 'react-redux';
import CardsPanel from './CardsPanel';
import {
  getCardsToDisplay,
  getCurrentSelection,
  removeCarrierAuthorization,
  setFiltersOpen,
} from '../store/carrierAuthorizationsSlice';
import { resetCarrierAuthWizardData } from '../store/createNewCarrierAuthSlice';
import { getFilterIdentifierCount } from '../../filters/store/filtersSlice';

const mapState = state => ({
  carrierAuthorizationsCards: getCardsToDisplay(state),
  carrierAuthorizationsCardsLength:
    state.loadingManagement.carrierAuthorizations.carrierAuthorizationsCards.length,
  carrierAuthorizationsPending:
    state.loadingManagement.carrierAuthorizations.carrierAuthorizationsPending,
  currentSelection: getCurrentSelection(state),
  filterIdentifierCount: getFilterIdentifierCount(state),
  filtersOpen: state.loadingManagement.carrierAuthorizations.filtersOpen,
  headerSubtitle: state.loadingManagement.carrierAuthorizations.headerSubtitle,
});

export default connect(mapState, {
  removeCarrierAuthorization,
  resetCarrierAuthWizardData,
  setFiltersOpen,
})(CardsPanel);
